/* eslint-disable react/prop-types */
import classNames from "classnames";
import classes from "./header.module.scss";
import Label from "@/components-library/widgets/label";
function Header({ isOpen, label, className }) {
  return (
    <div className={classNames(classes.header, className)}>
      <Label tag="p" align="start" size="md" color="secondary" weight="bold">
        {label}
      </Label>
      <img
        src={
          isOpen ? "/images/icons/icon-meno.svg" : "/images/icons/icon-piu.svg"
        }
        alt="close"
      />
    </div>
  );
}

export default Header;
